import * as React from "react";
const SvgQuote = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 20 20",
    ...props
  },
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      d: "m18.291 7.267-.02-.14-.022.005a3.75 3.75 0 1 0-3.666 4.535c.186 0 .364-.029.542-.054-.058.193-.117.39-.212.566-.095.257-.243.48-.39.704-.124.242-.342.406-.502.614-.167.201-.396.335-.576.503-.178.175-.41.262-.595.386-.194.11-.362.233-.542.292l-.45.184-.394.165.403 1.615.498-.12c.159-.04.353-.086.574-.142.226-.042.466-.156.735-.26.264-.12.572-.198.857-.39.286-.18.617-.332.909-.576.282-.25.623-.468.875-.787.275-.298.546-.611.757-.968.244-.34.41-.713.585-1.082.159-.37.286-.747.39-1.114.198-.735.286-1.433.32-2.03a10.37 10.37 0 0 0-.023-1.456c-.012-.15-.03-.3-.053-.45Zm-9.166 0-.021-.14-.022.005a3.75 3.75 0 1 0-3.666 4.535c.186 0 .364-.029.542-.054-.058.193-.117.39-.212.566-.095.257-.243.48-.39.704-.124.242-.341.406-.501.614-.168.201-.396.335-.577.503-.178.175-.41.262-.595.386-.193.11-.362.233-.542.292l-.449.184-.394.163.403 1.616.498-.12.574-.143c.226-.041.467-.155.735-.26.264-.119.572-.198.857-.389.286-.181.617-.333.909-.576.282-.251.623-.469.875-.787.275-.298.546-.612.757-.968.244-.34.41-.714.585-1.083a9.23 9.23 0 0 0 .39-1.113c.198-.735.286-1.434.32-2.031a10.38 10.38 0 0 0-.023-1.456 6.67 6.67 0 0 0-.053-.448Z"
    }
  )
);
export default SvgQuote;
